// All user related database operations can be defined here.

import http from "../http-common";

class ClinicalUserDataService {
  doLogin(model: IClinicalLoginRequestModel) {
    return http.post(`clinicaluser/login`, model);
  }
  getUser() {
    return http.get(`clinicaluser`, {withCredentials: true});
  }
  logout() {
    return http.get(`clinicaluser/logout`, {withCredentials: true});
  }
}

export interface IClinicalLoginRequestModel {
  username: string
  password: string
}

const datservice = new ClinicalUserDataService();

export default datservice;
